<template>
  <div class="limit-success">
    <CommonBanner
      :tagline="$t`Ваш новый лимит на покупки`"
      :title="$currencyFormatter(limitAmount)"
    />
    <CommonButton @click="$router.replace('/bank/red')" spaced>
      {{ $t`Вернуться в Мой Red` }}
    </CommonButton>
  </div>
</template>

<script>
import CommonBanner from "@/components/shared/banner/CommonBanner";
import CommonButton from "@/components/shared/button/CommonButton";

export default {
  components: {
    CommonBanner,
    CommonButton,
  },
  computed: {
    limitAmount() {
      return this.$route.query.limit;
    },
  },
};
</script>

<style lang="scss" scoped></style>
